/**
 * RN-062 — Sessões Inactivas.
 * No browser a sessão termina após 8 horas sem actividade do utilizador.
 *
 * Quem manda é o servidor (recusa renovar um refresh token parado há mais
 * tempo do que o limite). Isto aqui é o lado do ecrã: guarda o momento da
 * última actividade para que, ao reabrir a janela no dia seguinte, o painel
 * nem chegue a aparecer — vai directo ao login, com os dados da sessão limpos.
 */
const CHAVE = 'dozy-last-activity';
const HORAS = 8;
const LIMITE_MS = HORAS * 3600 * 1000;

export const marcarActividade = () => {
  try { localStorage.setItem(CHAVE, String(Date.now())); } catch { /* sem storage */ }
};

/** true se a sessão esteve parada para lá do limite. */
export const sessaoExpiradaPorInactividade = () => {
  try {
    const t = Number(localStorage.getItem(CHAVE));
    if (!t) return false;            // sem marca (sessão antiga) → não force logout
    return Date.now() - t > LIMITE_MS;
  } catch {
    return false;
  }
};

export const limparActividade = () => {
  try { localStorage.removeItem(CHAVE); } catch { /* sem storage */ }
};

/**
 * Regista actividade real do utilizador (com travão: no máximo uma escrita
 * por minuto, para não tocar no localStorage a cada movimento).
 */
export const observarActividade = () => {
  let ultima = 0;
  const aoInteragir = () => {
    const agora = Date.now();
    if (agora - ultima < 60000) return;
    ultima = agora;
    marcarActividade();
  };
  const eventos = ['click', 'keydown', 'pointerdown', 'scroll', 'visibilitychange'];
  eventos.forEach((e) => window.addEventListener(e, aoInteragir, { passive: true }));
  return () => eventos.forEach((e) => window.removeEventListener(e, aoInteragir));
};
